import * as React from 'react'

import { useReadAloud } from './readAloudContext'
import { ReadAloudSection } from './readAloudSection'

import { ClipSource } from '../../libs/speech/clipSource'

interface ReadAloudContentProps {
  children: React.ReactNode;
  label: string;
  source?: ClipSource | null;
}

const ReadAloudContent = ({ children, label, source, }: ReadAloudContentProps) => {
  const { readAloudEnabled, } = useReadAloud()

  if (!readAloudEnabled) { return children }

  return <ReadAloudSection content={children} label={label} source={source} />
}

export { ReadAloudContent }
